import styled from 'astroturf/react'
import { useSelector } from 'react-redux'

import PaymentSummary from 'components/payment/summary'
import { chargeSelector } from 'selectors/payment'
import { useI18n } from 'locales'
import _Info from "payment_info-Info.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/cancellation/form/payment_info.js?styleId=Info";
import _Summary from "payment_info-Summary.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/cancellation/form/payment_info.js?styleId=Summary";


const Info = /*#__PURE__*/styled('div', null, {
  displayName: "Info",
  styles: _Info
})

const Summary = /*#__PURE__*/styled(PaymentSummary, null, {
  displayName: "Summary",
  styles: _Summary
})

const PaymentInfo = () => {
  const { i18n } = useI18n()
  const charge = useSelector(chargeSelector)
  return (
    <>
      <Info>
        {i18n.t('booking.templates.payment.information')}
      </Info>
      <Summary
        charge={charge}
        refundNote
      />
    </>
  )
}

export default PaymentInfo
